if (!customElements.get("card-image-carousel")) {
  customElements.define(
    "card-image-carousel",
    class CardImageCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(
          this.querySelectorAll("[data-carousel-slide]")
        );
        if (this.slides.length < 2) return;

        this.currentIndex = this.slides.findIndex(
          (slide) => !slide.hasAttribute("hidden")
        );
        if (this.currentIndex < 0) this.currentIndex = 0;

        this.querySelector("[data-carousel-prev]")?.addEventListener(
          "click",
          this.onNavClick.bind(this, -1)
        );
        this.querySelector("[data-carousel-next]")?.addEventListener(
          "click",
          this.onNavClick.bind(this, 1)
        );
      }

      onNavClick(direction, event) {
        event.preventDefault();
        event.stopPropagation();
        this.goTo(this.currentIndex + direction);
      }

      goTo(index) {
        const nextIndex =
          (index + this.slides.length) % this.slides.length;
        if (nextIndex === this.currentIndex) return;

        this.slides[this.currentIndex].setAttribute("hidden", "");
        this.slides[nextIndex].removeAttribute("hidden");
        this.currentIndex = nextIndex;
      }
    }
  );
}
